<template>
  <div class="animated" v-if="samples">
    <b-progress :max="max" height="1rem">
      <b-progress-bar :value="value" :variant="variant" class="text-muted">
        <strong>{{ value }} / {{ max }}</strong>
      </b-progress-bar>
    </b-progress>
  </div>
</template>

<script>

  import SampleCollection from "../../../collections/lab/SampleCollection";

  export default {
    name: 'SampleReceivedBar',
    props: {
      samples: {
        type: SampleCollection,
        default: () => null
      },
    },
    data() {
      return {
        max: 0,
        value: 0,
        variant: null
      }
    },
    methods: {
      init() {
        if(this.samples) {
          this.max = this.samples.models.length;
          this.value = 0;
          this.samples.each((sample) => {
            sample.getSampleStatusLogs().each((log) => {
              let status = log.getSampleStatus();
              if(status && status.status === 'Received') {
                this.value++;
              }
            });
          });
          if((this.value / this.max) >= 0.8) {
            this.variant = 'success';
          } else if((this.value / this.max) >= 0.6) {
            this.variant = null;
          } else if((this.value / this.max) >= 0.4) {
            this.variant = 'warning';
          } else {
            this.variant = 'danger';
          }
        }
      }
    },
    created() {
      this.init();
    }
  }
</script>
